var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67588 8.80089L4.98038 6.10539C4.94104 6.06596 4.89088 6.03909 4.83626 6.0282C4.78163 6.0173 4.72501 6.02287 4.67355 6.0442C4.6221 6.06553 4.57814 6.10166 4.54724 6.148C4.51634 6.19435 4.4999 6.24882 4.5 6.30452V11.6955C4.5 11.9464 4.80375 12.0724 4.98038 11.8946L7.67588 9.19914C7.70207 9.17302 7.72285 9.14198 7.73703 9.10781C7.7512 9.07364 7.7585 9.03701 7.7585 9.00002C7.7585 8.96303 7.7512 8.92639 7.73703 8.89223C7.72285 8.85806 7.70207 8.82702 7.67588 8.80089Z",
    fill: "#373473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96875 0C1.44661 0 0.945846 0.207421 0.576634 0.576634C0.207421 0.945846 0 1.44661 0 1.96875L0 16.0312C0 17.118 0.882 18 1.96875 18H16.0312C16.5534 18 17.0542 17.7926 17.4234 17.4234C17.7926 17.0542 18 16.5534 18 16.0312V1.96875C18 1.44661 17.7926 0.945846 17.4234 0.576634C17.0542 0.207421 16.5534 0 16.0312 0H1.96875ZM1.6875 1.96875C1.6875 1.89416 1.71713 1.82262 1.76988 1.76988C1.82262 1.71713 1.89416 1.6875 1.96875 1.6875H10.6875V16.3125H1.96875C1.89416 16.3125 1.82262 16.2829 1.76988 16.2301C1.71713 16.1774 1.6875 16.1058 1.6875 16.0312V1.96875ZM12.375 16.3125V1.6875H16.0312C16.1058 1.6875 16.1774 1.71713 16.2301 1.76988C16.2829 1.82262 16.3125 1.89416 16.3125 1.96875V16.0312C16.3125 16.1058 16.2829 16.1774 16.2301 16.2301C16.1774 16.2829 16.1058 16.3125 16.0312 16.3125H12.375Z",
    fill: "#373473"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSidebar);
export default __webpack_public_path__ + "static/media/open_sidebar.3e463c21b4bb6be2cb0aac6e7d5766dc.svg";
export { ForwardRef as ReactComponent };